import React, { ReactElement } from 'react'

export const FORM_TRACKING_FORM_STEP_INDEX_ATTR = 'data-form-step-index'
export const FORM_TRACKING_FORM_STEP_NAME_ATTR = 'data-form-step-name'
export const FORM_TRACKING_IS_FINAL_STEP_ATTR = 'data-is-final-step'
export const FORM_TRACKING_FORM_NAME_ATTR = 'data-form-name'

interface FormTrackingSettings {
    formName?: string
    formStepIndex?: string
    formStepName?: string
    isFinalStep?: boolean
}

const getFormTrackingSettingsAttributeProps = (settings: FormTrackingSettings) => ({
    [FORM_TRACKING_FORM_NAME_ATTR]: settings.formName,
    [FORM_TRACKING_FORM_STEP_INDEX_ATTR]: settings.formStepIndex,
    [FORM_TRACKING_FORM_STEP_NAME_ATTR]: settings.formStepName,
    [FORM_TRACKING_IS_FINAL_STEP_ATTR]: settings.isFinalStep,
})

/**
 * @description This component will be used to set the tracking settings for a form.
 * You don't need to use this component if the form is not a multi step form.
 *
 * @todo logic for this component is not yet implemented in the form analytics hook.
 */
export const FormTrackingSettings = ({
    settings,
    children,
}: {
    settings: FormTrackingSettings
    children: React.ReactNode
}): ReactElement => {
    return (
        <div className="contents" {...getFormTrackingSettingsAttributeProps(settings)}>
            {children}
        </div>
    )
}
